import React, { useEffect, useRef, useState } from "react";
import { IonSpinner } from "@ionic/react";
import { Check } from "react-feather";
import "./index.css";

const STEP_MESSAGES = {
  upload: "Loading your image...",
  colors: "Detecting colors...",
  analyze: "Analyzing for best conversion...",
  retrace: "Enhancing image with AI...",
  ready: "Ready!",
};

const ProcessingOverlay = ({ 
  isVisible, 
  currentStep = "upload", 
  previewImage = null,
  onComplete 
}) => {
  const [showReady, setShowReady] = useState(false);
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    if (currentStep === "ready") {
      setShowReady(true);
      const timer = setTimeout(() => {
        onCompleteRef.current?.();
      }, 500);
      return () => clearTimeout(timer);
    } else {
      setShowReady(false);
    }
  }, [currentStep]);

  // Safety timeout: auto-dismiss if stuck on any step for over 30s
  useEffect(() => {
    if (!isVisible) return;
    const timeout = setTimeout(() => {
      console.warn("⚠️ ProcessingOverlay: Stuck for 30s, auto-dismissing");
      onCompleteRef.current?.();
    }, 30000);
    return () => clearTimeout(timeout);
  }, [isVisible, currentStep]);

  if (!isVisible) return null;

  const message = STEP_MESSAGES[currentStep] || "Processing...";

  return (
    <div className="processing-overlay" data-tutorial-busy={`processing-${currentStep}`}>
      <div className="processing-container">
        {/* Spinner or Check */}
        {showReady ? (
          <div className="processing-check">
            <Check size={48} strokeWidth={2.5} />
          </div>
        ) : (
          <IonSpinner name="crescent" className="processing-spinner" />
        )}
        
        {/* Message */}
        <p className="processing-message">{message}</p>
        
        {/* Step dots */}
        <div className="processing-dots">
          {Object.keys(STEP_MESSAGES).map((step, index) => {
            const currentIndex = Object.keys(STEP_MESSAGES).indexOf(currentStep);
            const isCompleted = index < currentIndex;
            const isCurrent = step === currentStep;
            
            return (
              <div 
                key={step}
                className={`dot ${isCompleted ? 'completed' : ''} ${isCurrent ? 'current' : ''}`}
              />
            );
          })}
        </div>
        
        {/* Preview thumbnail if available */}
        {previewImage && (
          <div className="processing-preview">
            <img src={previewImage} alt="Your upload" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProcessingOverlay;
